import React from 'react';
import { RouteComponentProps, withRouter } from "react-router-dom";
import styled from 'styled-components';
import { NavigationModule } from "UI-Dash-Commons-UI";
import { DOCS_LEFT_MENU } from "../constants/constants";

import DocsMenuSection from "../types/DocsMenuSection";
import TopNavComponent from './TopNavComponent';

type ContentComponentProps = RouteComponentProps;

class ContentComponent extends React.Component<ContentComponentProps>
{
    private getBreadcrumbs: ( pathname: string, menu: DocsMenuSection ) => Array<DocsMenuSection> = ( pathname: string, menu: DocsMenuSection ) =>
    {
        const menuSectionCrumbs: Array<DocsMenuSection> = [];
        const menuSectionStack: Array<DocsMenuSection> = [ menu ];

        while ( menuSectionStack.length > 0 )
        {
            let menuSectionCrumb: DocsMenuSection = ( menuSectionStack.pop() as DocsMenuSection );

            if ( menuSectionCrumb.isPage && pathname.indexOf( menuSectionCrumb.url ) > -1 )
            {
                if ( menuSectionCrumb.breadcrumbUrl )
                {
                    menuSectionCrumb = {
                        children: menuSectionCrumb.children,
                        displayName: menuSectionCrumb.displayName,
                        id: menuSectionCrumb.id,
                        isPage: menuSectionCrumb.isPage,
                        url: menuSectionCrumb.breadcrumbUrl,
                    }
                }

                menuSectionCrumbs.push( menuSectionCrumb );
            }

            if ( menuSectionCrumb.children.length > 0 )
            {
                menuSectionStack.push( ...menuSectionCrumb.children );
            }
        }

        // Andrew currently does not want breadcrumbs on the landing page
        if (menuSectionCrumbs.length === 1)
        {
            return [];
        }

        return menuSectionCrumbs;
    };

    componentDidUpdate(prevProps)
    {
        if (this.props.location !== prevProps.location)
        {
            window.scrollTo(0, 0);
        }
    }

    render()
    {
        const breadcrumbs = this.getBreadcrumbs( this.props.location.pathname, DOCS_LEFT_MENU );

        return (
            <MainWrapper>
                <TopNavComponent/>
                <BreadcrumbsWrapper>
                    <NavigationModule.components.Breadcrumbs
                        breadcrumbs={breadcrumbs}
                    />
                </BreadcrumbsWrapper>
                <ContentWrapper>
                    {this.props.children}
                </ContentWrapper>
            </MainWrapper>
        );
    }
}

const ContentComponentWithRouter = withRouter( ContentComponent );

export default ContentComponentWithRouter;

const MainWrapper = styled.main`
  padding-left: 260px;
  flex-grow: 1;
`;

const BreadcrumbsWrapper = styled.div`
  height: 48px;
  width: 100%;

  position: fixed;
  z-index:10;
  
  margin-top: 48px;
`;

const ContentWrapper = styled.div`
  padding: 142px 0px 40px 75px;
  width: 1000px;
`;
